export class Barcos {
  constructor(public idempresa: string, public nombrebarco: string, public emailbarco?: string, public _id?: string) {}
}
